/*
 * Copyright (c) 2022. Dave van Rijn Development
 */
import './style/pricesPage.scss';

import React, {useEffect, useState} from 'react';
import {Helmet} from 'react-helmet';
import TextContainer from '../textContainer/textContainer';
import {AwesomeIcon, remToPx, sendGaPageView} from '@dvrd/dvr-controls';
import classNames from 'classnames';
import {Price, PriceLabel, prices} from '../../util/prices';
import {getImg, getImgSizes, getImgSources} from '../../util/utils';

export default function PricesPage() {
    const [openCategory, setOpenCategory] = useState<string | null>(prices.length === 1 ? prices[0].title : null);

    function onClickCategory(title: string) {
        return function () {
            if (prices.length === 1) return;
            if (openCategory === title) setOpenCategory(null);
            else setOpenCategory(title);
        };
    }

    function calcMaxHeight(title: string): string {
        if(prices.length === 1) return 'unset';
        const container: HTMLElement | null = document.getElementById(`price-container-${title}`);
        if (!container) return '4rem';
        let height: number = remToPx(4);
        const header = container.querySelector('div.header-container');
        const pricesContainer = container.querySelector('div.prices');
        const headerHeight = header?.getBoundingClientRect().height;
        if (openCategory !== title) return (headerHeight ?? height) + 'px';
        if (header) height = headerHeight!;
        if (pricesContainer) height += pricesContainer.getBoundingClientRect().height;
        return height + 'px';
    }

    function renderTexts() {
        return (
            <TextContainer invert title='Tarieven'>
                <div className='price-content'>
                    <div className='price-list'>
                        {prices.map(renderCategory)}
                    </div>
                    <img src={getImg('prices/leonique-veld-x480')}
                         srcSet={getImgSources('prices/leonique-veld', [300, 480])}
                         sizes={getImgSizes([300, 480], 480)} alt="Bowie's" className='img'/>
                </div>
            </TextContainer>
        );
    }

    function renderCategory(price: Price, index: number) {
        const {title, labels} = price;
        const isOpen = openCategory === title;
        return (
            <div key={index} className={classNames('price-container', isOpen && 'open')} id={`price-container-${title}`}
                 style={{maxHeight: calcMaxHeight(title)}}>
                <div className={classNames('header-container', prices.length === 1 && 'single')}
                     onClick={onClickCategory(title)}>
                    <label className='header-title'>{title}</label>
                    <AwesomeIcon name='chevron-down' className='chevron'/>
                </div>
                <div className='prices'>
                    {labels.map((label: PriceLabel, index: number) => (
                        <label key={index} className={classNames(label.className)}>{label.text}</label>
                    ))}
                </div>
            </div>
        );
    }

    useEffect(() => {
        sendGaPageView('/tarieven');
    }, []);

    return (
        <div className='prices-page' id='prices'>
            <Helmet>
                <title>Bowie's | Tarieven</title>
                <link rel='canonical' href={`https://bowies.nl/tarieven`}/>
            </Helmet>
            {renderTexts()}
        </div>
    );
}